// extracted by mini-css-extract-plugin
export default {"Period":"index__Period__U4cWq"};